<template>
    <div class="c-conversation__wrapper"
        :data-component-name="$options.name"
    >

        <div class="c-conversation-header" v-if="project">
            <div class="close-panel-button">
                <q-icon name="arrow_back_ios" @click="$emit('close-panel')" />
            </div>

            <div class="row flex-center full-width">
                <div class="-avatar">
                    <UserAvatar :name="project.name + project.name.split('').reverse().join('')" />
                </div>
                <div class="-details flex-grow">
                    <div class="-project c-messages-header" v-if="project">

                        <div class="-assignedTo q-ml-sm">
                            {{project.name}}
                            <ProjectCardToggle class="-userprofile-info__toggle q-ml-sm" :myAssignments="true"
                                :projectID="project.id" :size="'12px'" />
                        </div>
                        <div class="-range q-ml-sm">
                            du {{ date2str(project.assignmentsDateRange.from).short }}
                            au {{ date2str(project.assignmentsDateRange.to).short }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="c-conversation-body" v-if="project && !hideData">
            <div class="-message">
                <h2 class="q-mb-lg">Bonjour <span v-html="userProfile.name.split(' ')[0]" />,</h2>
                <div v-if="project.assignmentsDateRange.count>1">
                    <p>
                        Vous avez <u class="-text-blue">{{ project.assignmentsDateRange.count }} affectations en attente</u> d'acceptation
                        <span v-if="project.assignmentsDateRange.countCanceled > 1 ">
                            et <u class="-text-red">{{ project.assignmentsDateRange.countCanceled }} affectations annulées</u>
                        </span>
                        <span v-if="project.assignmentsDateRange.countCanceled == 1 ">
                            et <u class="-text-red">{{ project.assignmentsDateRange.countCanceled }} affectation annulée</u>
                        </span>
                        pour le projet <strong>{{project.name}}</strong>.
                    </p>
                    <p>
                        Merci de confirmer votre présence dans les plus brefs délais.
                    </p>
                </div>
                <div v-else-if="project.assignmentsDateRange.count==1">
                    <p>
                        Vous avez <u class="-text-blue">{{ project.assignmentsDateRange.count }} affectation en attente</u> d'acceptation
                        <span v-if="project.assignmentsDateRange.countCanceled > 1 ">
                            et <u class="-text-red">{{ project.assignmentsDateRange.countCanceled }} affectations annulées</u>
                        </span>
                        <span v-if="project.assignmentsDateRange.countCanceled == 1 ">
                            et <u class="-text-red">{{ project.assignmentsDateRange.countCanceled }} affectation annulée</u>
                        </span>
                        pour le projet <strong>{{project.name}}</strong>.
                    </p>
                    <p>
                        Merci de confirmer votre présence dans les plus brefs délais.
                    </p>
                </div>
                <div v-else-if="project.assignmentsDateRange.count == 0 && project.assignmentsDateRange.countCanceled > 0">
                    <p>
                        Vous avez <u class="-text-red">{{ project.assignmentsDateRange.countCanceled }} affectations annulées</u>.
                    </p>
                    <p>
                        Merci de confirmer votre présence dans les plus brefs délais.
                    </p>
                </div>
                <div v-if="project.assignmentsDateRange.count == 0 && project.assignmentsDateRange.countCanceled == 0">
                    <p class="-text-green-dark">
                        <strong><q-icon name="check_circle_outline" size="20px" color="green" class="q-mr-sm" />Vous n'avez pas d'affectation en attente pour le projet {{ project.name }}. Merci!</strong>
                    </p>
                    <p>
                        Cet avis disparaitra automatiquement dans 3 secondes.
                    </p>
                </div>
            </div>

            <div class="-body q-mt-md" ref="body" v-if="userAssignments && (userAssignments.data.length || userAssignments.paginatorInfo.hasMorePages)">

                <div class="-row -select-all">
                    <div class="-checkboxes text-right">
                        <q-checkbox dense v-model="selectAll" size="36px" color="blue"
                            :class="{'is-indeterminate': selectAll===null}" />
                    </div>
                    <div class="flex-fill cursor-pointer" @click="selectAll=!selectAll">
                        {{ this.selectAllLabel }}
                        <span v-if="userAssignments && userAssignments.data.length">
                            ({{ assignmentCount }} / {{ project.assignmentsDateRange.count + project.assignmentsDateRange.countCanceled
                            }})
                        </span>
                
                    </div>
                    <div class="-acceptation q-ml-auto">
                        <AcceptationSelect ref="acceptSelected" :userProfileID="userProfile.id" :lastDenyReason="lastDenyReason"
                            :outline="false" size="9px" acceptButton="Accepter la sélection" denyButton="Refuser la sélection"
                            @accept-assignment="acceptAssignment($event, project, project.id)" 
                            :assignmentError="selected.length == 0"
                        />
                    </div>
                </div>


                <div class="-header -row -hidden-mobile">
                    <div class="-checkboxes">
                    </div>
                    <div class="-dates">
                        Dates d'affectations
                    </div>
                    <!-- <div class="-hours">
                        Heures
                    </div> -->
                    <div class="-shifts">
                        Quarts de travail
                    </div>
                    <!-- <div class="-professions">
                        Metier
                    </div> -->
                    <div class="-acceptation text-right">
                    </div>
                </div>



                <div class="-assignments-list__wrap" v-if="!hideData && userAssignments && userAssignments.data.length>0">
                    <div class="-alternate">
                        <PendingAssignment
                            class="-row -alternate -assignement-component"
                            :class="{
                                '-is-accepting' : acceptedAssignments.includes(userAssignment.id)
                            }"
                            :key="userAssignment.id"
                            :ref="'assignment'+userAssignment.id"
                            v-for="(userAssignment) in userAssignments.data"
                            :assignment="userAssignment"
                            :project="project"
                            :selected="selected"
                            :acceptedAssignments="acceptedAssignments"
                            @set-selected="setSelected(userAssignment.id)"
                            @accept-assignment="acceptAssignment($event, project, project.id, userAssignment.id)"
                        />
                    </div> 
                </div> 

                <div class="-row -load-more">
                    <div class="text-center full-width">
                        <span class="-load-more-button"
                            @click="loadMoreUserAssignments()"
                            v-if="!$apollo.loading && userAssignments && userAssignments.paginatorInfo.hasMorePages"
                        >
                            <q-icon name="add" class="q-mr-xs" />
                            {{ project.assignmentsDateRange.count + project.assignmentsDateRange.countCanceled - userAssignments.data.length }}
                            <span
                                v-if="project.assignmentsDateRange.count + project.assignmentsDateRange.countCanceled - userAssignments.data.length > 1"
                            >affectations de plus</span>
                            <span
                                v-else
                            >affectation de plus</span>
                        </span>
                        <span v-if="$apollo.loading">
                            <q-spinner
                                color="primary"
                                class="q-mr-xs"
                            />
                            Chargement en cours
                        </span>
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
import { USERASSIGNMENTS } from "@/graphql/assignment/queries";
import { ACCEPTNOTIFICATIONASSIGNMENT } from "@/graphql/notification/mutations"
import { PROJECTSINBOX } from "@/graphql/notification/queries";
import { relativeDate, date2str } from "@/js/dateUtilities"
import AcceptationSelect from "@/components/forms/AcceptationSelect"
import PendingAssignment from '@/components/notifications/PendingAssignment'

export default {
    name: 'PendingV2',
    components: { 
        AcceptationSelect, 
        PendingAssignment 
    },
    props: {
        userProfile: {
            type: Object,
            default(){
                return null
            }
        },
        project: {
            type: Object,
            default: null
        },
        isMobile: {
            type: Boolean,
            default: false
        }
    },
    data(){
    	return {
            pageSize: 50,
            skipQueriesStart: false,
            selectAll: false,
            selectAllLabel: 'Sélectionner tout',
            selected: [],
            lastDenyReason: '',
            acceptedAssignments: [],
            hideData: false,
            refetchTO: null,
            currentProjectID: null,
            // loadingMore: false,
    	}
    },
    mounted() {
        if (this.project) this.currentProjectID = this.project.id
    },
    computed: {
        assignmentCount: function () {
            if (!this.userAssignments) return 0;
            // if (this.userAssignments.data.length > this.project.assignmentsDateRange.count) return this.project.assignmentsDateRange.count + this.project.assignmentsDateRange.countCanceled
            return this.userAssignments.data.length;
        },

        projectChange: function () {
            return this.currentProjectID != this.project.id
        }
    },
    watch: {
        project: function(){
            if (this.projectChange) {
                this.hideData = true;
                this.selectAll = false;
                this.selected = [];
                this.acceptedAssignments = [];
            }

            if(this.project) this.skipQueriesStart = false
            if(!this.project) this.skipQueriesStart = true

            clearTimeout(this.refetchTO)
            this.currentProjectID = this.project.id
        },

        selected: function(){
            this.selectAllLabel="Sélectionner tout";
            if(!this.userAssignments?.data) return this.selectAll=false;
            let unselected=this.userAssignments.data.filter(obj => !this.selected.includes(obj.id))
            if(unselected.length>0 && this.selected.length>0) return this.selectAll=null;
            if(this.userAssignments?.data.length==0 || this.selected.length==0) return this.selectAll=false;
            if(unselected.length==0){
                this.selectAllLabel="Désélectionner tout";
                return this.selectAll=true;
            } 
        },

        selectAll: function(){
            if(this.selectAll===false) this.selected=[];
            if(this.selectAll){
                this.selected=[];
                this.userAssignments.data.forEach(function(item){
                    this.selected.push(item.id)
                }.bind(this))
            }
        },

        assignmentCount: function () {
            let assignmentsID = this.userAssignments.data.map(function (item) { return item["id"] });
            let filteredArray = assignmentsID.filter(value => this.selected.includes(value));

            if (filteredArray.length != this.selected.length) {
                this.selected = [];
                this.selectAll = false;
            }
        }
    },
    methods: {
        date2str(date) {
            return date2str(date);
        },

        getRelativeDate(date) {
            return relativeDate(date);
        },

        setSelected(notificationID){
            if(this.selected.includes(notificationID)){
                this.selected=this.selected.filter(obj => obj != notificationID)
            }else{
                this.selected.push(notificationID)
            }
        },


        loadMoreUserAssignments(){
            this.$apollo.queries.userAssignments.fetchMore({
                variables: {
                    page: Math.ceil((this.userAssignments.data.length+1)/this.pageSize),
                    first: this.pageSize,
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    return {
                        userAssignments: {
                            __typename: previousResult.userAssignments.__typename,
                            data: [...previousResult.userAssignments.data, ...fetchMoreResult.userAssignments.data],
                            paginatorInfo: fetchMoreResult.userAssignments.paginatorInfo,
                        }
                    }

                }
            })
        },


        acceptAssignment(option, project, projectID=null, assignmentID=null){
            // console.log(option.value)
            let assignmentIDs=this.selected;
            if(option.reason) this.lastDenyReason=option.reason;
            if (assignmentID) {
                assignmentIDs = [assignmentID];
                if (option.value != "maybe") this.acceptedAssignments.push(assignmentID);
            } else if (this.selected) {
                this.acceptedAssignments.push(...assignmentIDs)
                this.selected = [];
                this.selectAll = false;
            }
            clearTimeout(this.refetchTO)

            this.$apollo.mutate({
                mutation: ACCEPTNOTIFICATIONASSIGNMENT,
                variables: {
                    assignmentID: assignmentIDs,
                    projectID: projectID,
                    userProfileID: this.userProfile.id,
                    action: option.value,
                    message: option.reason,
                    page: 1,
                    first: 1
                }
            }).then(function () {
                
                clearTimeout(this.refetchTO)
                this.refetchTO=setTimeout(()=>{
                    this.refetchAllAssignments(this.userAssignments.data.length);

                    this.acceptedAssignments.forEach(function (assignmentID) {
                        this.userAssignments.data=this.userAssignments.data.filter(item => item.id!=assignmentID)
                    }.bind(this))

                    this.$eventBus.$emit('notifications-count', { projectID: this.projectID } )

                }, 1000)

            }.bind(this))

        },

        refetchAllAssignments(pageSize){
            if(pageSize==0) pageSize=1;

            if(pageSize<this.pageSize) pageSize = this.pageSize;

            this.$apollo.queries.userAssignments.fetchMore({
                variables: {
                    page: 1,
                    first: pageSize,
                },
                watchLoading(){
                    this.loading=false;
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    this.refetchProject()
                    return {
                        userAssignments: {
                            __typename: previousResult.userAssignments.__typename,
                            data: fetchMoreResult.userAssignments.data,
                            paginatorInfo: fetchMoreResult.userAssignments.paginatorInfo,
                        }
                    }
                }
            })
        },

        refetchProject(){
            this.$apollo.query({
                query: PROJECTSINBOX,
                fetchPolicy: 'network-only',
                variables: { 
                    id: this.project.id,
                    userProfileID: this.userProfile.id,
                }
            }).then(function(){
                this.loadingMore=false;
            }.bind(this))
        },
    },

    apollo: {
        userAssignments : {
            query: USERASSIGNMENTS,
            fetchPolicy: 'network-only',	//cache-first, cache-and-network, cache-only, network-only, no-cache -> https://v4.apollo.vuejs.org/guide-composable/query.html#fetch-policy
            //debounce: 200,
            error(error){
                if (error.message) this.$q.notify({type: 'negative', message: 'Oh Oh', caption: error.message});
            },
            // watchLoading(isLoading){
            //     // if(!this.loadingMore){
            //     //     this.$emit('is-loading', isLoading)
            //     //     this.loading=isLoading;
            //     // }
            // },
            skip(){
                return this.skipQueriesStart
            },
            variables() {
                return {
                    userProfileID: this.userProfile.id,
                    projectID: this.project.id,
                    first: this.pageSize,
                    pending: true,
                    page: 1
                }
            },
            update(data) {
                this.hideData = false
                data.userAssignments.data.forEach(assignment => {
                    assignment.state = '-completed'
                    assignment.acceptation = {
                        label: 'Acceptée',
                        value: 'accepted',
                        icon: 'verified',
                        currentClass: '-completed'
                    }
                    if (assignment.deniedByUser) {
                        assignment.state = '-alert'
                        assignment.acceptation = {
                            label: 'Refusée',
                            value: 'denied',
                            icon: 'new_releases',
                            currentClass: '-denied'
                        }
                    }
                    if (assignment.maybeByUser) {
                        assignment.state = '-published'
                        assignment.acceptation = {
                            label: 'Peut-être',
                            value: 'maybe',
                            icon: 'help',
                            currentClass: '-maybe'
                        }
                    }
                    if (assignment.notification_pending || assignment.notification_sent) {
                        assignment.acceptation = {
                            label: 'En attente',
                            value: null,
                            icon: 'pending_actions',
                            currentClass: '-maybe'
                        }

                        assignment.state = '-published'
                    }

                    if (assignment.hasAssignmentError) {
                        // assignment.acceptation=null;
                        assignment.state = '-alert'
                    }

                    if (assignment.canceled) {
                        // assignment.acceptation=null;
                        assignment.state = '-canceled'
                        assignment.acceptation = {
                            label: 'Ne plus afficher',
                            value: 'cancel',
                            icon: 'help',
                            // currentClass: '-canceled'
                        }
                    }
                })
                // data.userAssignments.data=data.userAssignments.data.filter(item => !this.acceptedAssignments.includes(item.id))
                return data.userAssignments
            },
        }
    }

}

</script>